<div class="w-full py-12 flex flex-col items-center">
    <div class="w-full app-container flex items-center front mb-4">
        <div class="navigation hidden md:flex justify-between items-center gap-2">
            <div class="swiper-button-prev">
                <img loading="lazy" width="20" height="20" ngSrc="/assets/right-arrow.png" alt="prev" i18n-alt="@@caseStudiesSliderPrevAlt" />
            </div>
            <div class="swiper-button-next">
                <img loading="lazy" width="20" height="20" ngSrc="/assets/left-arrow.png" alt="prev" i18n-alt="@@caseStudiesSliderNextAlt" />
            </div>
        </div>
        <h2 class="heading-2 m-0 text-center flex-auto uppercase tracking-wider text-primary" style="margin: 0 !important" i18n="@@caseStudiesSliderHeading">Case studies</h2>

        <a [routerLink]="['/case-studies']" class="button text-primary self-end" i18n="@@caseStudiesSliderSeeMore"> See more </a>
    </div>

    <div class="w-full app-container app-container-p gap-6 py-8 items-center back">
        <div #swiperContainer class="swiper">
            <div class="swiper-wrapper">
                @for (caseStudy of caseStudiesResource.value(); track i; let i = $index) {
                    <div #slide class="swiper-slide relative" [ngStyle]="{ aspectRatio: aspectRatio() }" lazy="true">
                        <in2-case-case-study-slider-card [slide]="caseStudy"></in2-case-case-study-slider-card>
                    </div>
                }
            </div>

            <div class="swiper-pagination"></div>
        </div>
    </div>
</div>
